import React from "react";
import { tv } from "tailwind-variants";

interface SectionSeparatorProps {
  label: string;
  type?: "primary" | "secondary";
}

const sectionSeparatorVariants = tv({
  base: "px-[10px] py-[6px] rounded-[111px] min-w-fit uppercase",
  variants: {
    type: {
      primary: "bg-ominimo-400 text-white",
      secondary: "bg-gray-200 text-black",
    },
  },
  defaultVariants: {
    type: "primary",
  },
});

const sectionSeparatorBorderVariants = tv({
  base: "h-[1px] border-b border-dashed w-full",
  variants: {
    type: {
      primary: "border-ominimo-400",
      secondary: "border-gray-376",
    },
  },
  defaultVariants: {
    type: "primary",
  },
});

export const SectionSeparator: React.FC<SectionSeparatorProps> = ({ label, type }) => {
  return (
    <div className="flex items-center">
      <div className={sectionSeparatorVariants({ type })}>
        <p className="font-medium text-xs leading-[12px] tracking-[1.5px]">{label}</p>
      </div>
      <div className={sectionSeparatorBorderVariants({ type })} />
    </div>
  );
};
